module.exports = __webpack_public_path__ + "assets/img/logAudit-module6-1.5325ee68.jpg";